import { useCallback } from 'react';
import { useColor } from './useColor';
export function useAlpha() {
  var manager = useColor();
  var rgba = manager.getColor().getRGBA();
  var onAlphaChange = useCallback(function (alpha) {
    manager.emitColorChange(manager.getColor().setAlpha(alpha));
  }, []);
  return [rgba, onAlphaChange];
}